import { handleApiResponse, apiReadWithAuth } from '../../fetchUtils';

export const BEGIN_STUDENT_FORM_SUBMIT = 'BEGIN_STUDENT_FORM_SUBMIT'
export const SUBMIT_STUDENT_FORM_SUCCESS = 'SUBMIT_STUDENT_FORM_SUCCESS'
export const SUBMIT_STUDENT_FORM_FAILURE = 'SUBMIT_STUDENT_FORM_FAILURE'
export const BEGIN_FETCH_STUDENTS = 'BEGIN_FETCH_STUDENTS'
export const FETCH_STUDENTS_SUCCESS = 'FETCH_STUDENTS_SUCCESS'
export const FETCH_STUDENTS_FAILURE = 'FETCH_STUDENTS_FAILURE'
export const INVALIDATE_STUDENT_CACHE = 'INVALIDATE_STUDENT_CACHE'

function beginSubmit() {
  return { type: BEGIN_STUDENT_FORM_SUBMIT }
}

function submitStudentFormSuccess() {
  return { type: SUBMIT_STUDENT_FORM_SUCCESS }
}

function submitStudentFormFailure(errorMessage) {
  return { type: SUBMIT_STUDENT_FORM_FAILURE, errorMessage }
}

export function submitNewStudent(formData) {
  return dispatch => {
    dispatch(beginSubmit())
    return fetch('/students', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => handleApiResponse(response))
    .then(json => {
      if(json.id){
        dispatch(submitStudentFormSuccess())
      }
      else if(json.errors){ dispatch(submitStudentFormFailure(json.errors.join("\n"))) }
      else { dispatch(submitStudentFormFailure('Something went wrong!')) }
    })
    .catch(error => dispatch(submitStudentFormFailure(error.message)))
  }
}

function beginFetchStudents() {
  return { type: BEGIN_FETCH_STUDENTS }
}

function fetchStudentsSuccess() {
  return { type: FETCH_STUDENTS_SUCCESS }
}

function fetchStudentsFailure(error) {
  return { type: FETCH_STUDENTS_FAILURE, errorMessage: error.message }
}

export function fetchStudents(dispatch) {
  dispatch(beginFetchStudents())
  const callbacks = {
    onSuccess:  ()=>dispatch(fetchStudentsSuccess()),
    onError:    error=>dispatch(fetchStudentsFailure(error))
  }
  dispatch(apiReadWithAuth('/students?include=section,course,course.instructors.profile', callbacks))
}

